import { render, staticRenderFns } from "./Substep.vue?vue&type=template&id=40bb72a7&scoped=true&"
import script from "./Substep.vue?vue&type=script&lang=js&"
export * from "./Substep.vue?vue&type=script&lang=js&"
import style0 from "./Substep.vue?vue&type=style&index=0&id=40bb72a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bb72a7",
  null
  
)

export default component.exports